import moment from 'moment-timezone';
import Betslip from '@om-retail/betslip';
// import Betslip from '../../../../flex-betslip/dist';

const stateApp = {
    betslip: null,
    savedLottoNumbers: [],
    betslipConfig: null,
};

// getters
const getters = {
    betslip: (state) => state.betslip,
    betslipType: (state) =>
    {
        if (!state.betslip)
        {
            return null;
        }

        let type = null;

        for (const item of state.betslip.items)
        {
            const itemType = (item.type === 'outrights') ? 'sport' : item.type;

            if (type === null)
            {
                type = itemType;
            }
            else if (type !== itemType)
            {
                return 'mix';
            }
        }

        return type;
    },
    betslipItems: (state) =>
    {
        const items = [];

        if (state.betslip
        && state.betslip.items)
        {
            const itemsSorted = [];

            itemsSorted.splice(0, 0, ...state.betslip.items);

            const defaultDate = moment.utc();

            if (itemsSorted.length > 1)
            {
                itemsSorted.sort((a, b) =>
                {
                    const dateA = moment.utc(a.timestampAdd || defaultDate).valueOf();
                    const dateB = moment.utc(b.timestampAdd || defaultDate).valueOf();

                    if (dateA < dateB)
                    {
                        return -1;
                    }

                    if (dateA > dateB)
                    {
                        return 1;
                    }

                    return 0;
                });
            }

            const indexes = {};

            let i = 0;
            for (const item of itemsSorted)
            {
                let eventUniqueKey = `${item.type}_${item.eventId}`;

                // TODO lotto extended
                if (item.type === 'lotto')
                {
                    eventUniqueKey = `${eventUniqueKey}_${item.meta.selectedBall}`;
                }
                else if (item.type === 'sport'
                || item.type === 'outrights')
                {
                    eventUniqueKey = `${eventUniqueKey}_${item.meta.outcomeHash}`;
                }
                else if (item.type === 'vhorse')
                {
                    eventUniqueKey = `${eventUniqueKey}_${item.meta.marketId}_${item.meta.outcomeId}`;
                }

                indexes[eventUniqueKey] = i;

                i += 1;
            }

            for (const item of state.betslip.items)
            {
                let eventUniqueKey = `${item.type}_${item.eventId}`;

                // TODO lotto extended
                if (item.type === 'lotto')
                {
                    eventUniqueKey = `${eventUniqueKey}_${item.meta.selectedBall}`;
                }
                else if (item.type === 'sport'
                || item.type === 'outrights')
                {
                    eventUniqueKey = `${eventUniqueKey}_${item.meta.outcomeHash}`;
                }
                else if (item.type === 'vhorse')
                {
                    eventUniqueKey = `${eventUniqueKey}_${item.meta.marketId}_${item.meta.outcomeId}`;
                }

                items.push({
                    eventUniqueKey,
                    originalIndex: indexes[eventUniqueKey],
                    timestamp: moment.utc(item.matchDateUtc).valueOf(),
                    EventName: item.eventName,
                    ...item,
                });
            }
        }

        return items;
    },
    betslipItemsMapping: (state) =>
    {
        const selectedOutcomes = {};

        if (state.betslip != null)
        {
            for (const item of state.betslip.items)
            {
                let outcomeKey = `${item.type}_${item.eventId}`;

                if (item.type === 'lotto')
                {
                    outcomeKey = `${outcomeKey}_${item.meta.selectedBall}`;
                }
                else if (item.type === 'sport'
                || item.type === 'outrights')
                {
                    outcomeKey = `${outcomeKey}_${item.meta.outcomeHash}`;
                }
                else if (item.type === 'vhorse')
                {
                    outcomeKey = `${outcomeKey}_${item.meta.marketId}_${item.meta.outcomeId}`;
                }
                else if (item.type === 'lotto_extended')
                {
                    outcomeKey = `${outcomeKey}_${item.meta.outcomeId}_${item.meta.specifiers.drawnSum}`;
                }
                else
                {
                    continue;
                }

                selectedOutcomes[outcomeKey] = item;
            }
        }

        return selectedOutcomes;
    },
    betslipLottoNumbersMapping: (state) =>
    {
        const selectedOutcomes = {};

        if (state.betslip != null)
        {
            for (const item of state.betslip.items)
            {
                if (item.type !== 'lotto')
                {
                    continue;
                }

                selectedOutcomes[`${item.type}_${item.meta.selectedBall}`] = item;
            }
        }

        return selectedOutcomes;
    },
    betslipEventsMapping: (state) =>
    {
        const selectedEvents = {};

        if (state.betslip != null)
        {
            for (const item of state.betslip.items)
            {
                selectedEvents[`${item.type}_${item.eventId}`] = item;
            }
        }

        return selectedEvents;
    },
    betslipLoading: (state) => state.betslip && state.betslip.betslipLoading,
    savedLottoNumbers: (state) => state.savedLottoNumbers,
    betslipItemsCount: (state) =>
    {
        if (state.betslip
        && state.betslip.items)
        {
            return state.betslip.items.length;
        }

        return 0;
    },
    betslipConfig: (state) => state.betslipConfig,
};

// actions
const actions = {
    async getBetslipData(context, data)
    {
        let ticketData = {
            error: true,
            notice: 'CANNOT_FETCH_TICKET_DATA',
        };

        if (context.rootState.betslip.betslip != null)
        {
            ticketData = await context.rootState.betslip.betslip.getBetslip(
                data,
            );
        }

        context.dispatch('setTicketData', ticketData);
    },
    addBetslipError(context, error)
    {
        context.commit('addBetslipError', error);
    },
    removeBetslipError(context, error)
    {
        context.commit('removeBetslipError', error);
    },
    async selectBetslipOutcome(context, item)
    {
        if (item)
        {
            await context.commit('insertBetslipItem', item);
        }
    },
    setBetslipItemCallback(context)
    {
        context.commit('setBetslipItemCallback');
    },
    setBetslipGlobalRestrictions(context, data)
    {
        context.commit('setBetslipGlobalRestrictions', data);
    },
    changeBetslipType(context, data)
    {
        context.commit('changeBetslipType', data);
    },
    async clearSavedLottoNumbers(context)
    {
        await context.commit('clearSavedLottoNumbers');
    },
    saveItemsToStorage(context)
    {
        context.commit('saveItemsToStorage');
    },
    clearItems(context)
    {
        context.commit(
            'clearItems',
            {
                betslipType: context.getters.betslipType,
            },
        );
    },
    clearOtherItems(context, type)
    {
        context.commit(
            'clearItems',
            {
                betslipType: context.getters.betslipType,
                type,
            },
        );
    },
    swapLottery(context, data)
    {
        context.commit('swapLottery', data);
    },
    toggleBetslipDef(context, data)
    {
        context.commit('toggleBetslipDef', data);
    },
    loadBetslipStorageItems(context, data)
    {
        context.commit('loadBetslipStorageItems', data);
    },
    autoFillLottoBalls(context)
    {
        context.commit('initBetslipData');
        context.commit('autoFillLottoBalls');
    },
};

// mutations
const mutations = {
    setupBetslip(state, data)
    {
        if (state.betslip == null)
        {
            try
            {
                const config = {
                    ...data.config,
                };

                if (this.state.player.playerdata
                && this.state.player.playerdata.money
                && this.state.player.playerdata.money.currency
                && config.activeTicketConfigWithCurrency)
                {
                    const { currency } = this.state.player.playerdata.money;

                    if (config.activeTicketConfigWithCurrency[currency])
                    {
                        config.activeTicketConfig = config.activeTicketConfigWithCurrency[currency];
                    }
                }

                state.betslipConfig = config;

                const betslipInstance = new Betslip.Betslip({
                    ...config,
                    rawConfiguration: true,
                    globalRestrictions: this.state.offer.offerRestrictionsGlobal,
                });

                betslipInstance.setDeviceType('web');

                state.betslip = betslipInstance;

                if (window.webpackHotUpdate != null)
                {
                    state.betslip.setDebugMode(true);
                }
            }
            catch (e)
            {
                console.error(e);
            }
        }
    },
    addBetslipError(state, error)
    {
        if (state.betslip)
        {
            state.betslip.showBetslipError(error);
        }
    },
    removeBetslipError(state, error)
    {
        if (state.betslip)
        {
            state.betslip.hideBetslipError(error);
        }
    },
    autoFillLottoBalls(state)
    {
        const lotteryId = parseInt(window.localStorage.getItem('lastSelectedLottery'), 10);
        const selectedLottery = this.state.lotto.allLotteries[lotteryId];
        const [firstLotteryDraw] = JSON.parse(JSON.stringify((Object.values(selectedLottery.lottos))));

        if (state.savedLottoNumbers
        && state.betslip
        && this.state.lotto.allLotteries
        && firstLotteryDraw)
        {
            for (const ball of state.savedLottoNumbers)
            {
                if (ball <= selectedLottery.numbersOff)
                {
                    const item = {
                        eventId: firstLotteryDraw.lottoOfferId,
                        code: firstLotteryDraw.code,
                        eventDate: firstLotteryDraw.dateTime,
                        eventName: firstLotteryDraw.name,
                        type: 'lotto',
                        status: firstLotteryDraw.status,
                        restrictions: (firstLotteryDraw.restrictions)
                            ? firstLotteryDraw.restrictions
                            : firstLotteryDraw.rules,
                        meta:
                    {
                        lottoType: 'drawn',
                        outcomes: firstLotteryDraw.odds,
                        numbersToGuess: firstLotteryDraw.numbersToGuess,
                        numbersOff: firstLotteryDraw.numbersOff,
                        lottoId: firstLotteryDraw.lottoId,
                        selectedBall: ball,
                    },
                    };
                    state.betslip.addItem(item);
                }
            }
        }
    },
    async insertBetslipItem(state, item)
    {
        if (state.betslip)
        {
            await state.betslip.addItem(item);

            const savedNumbers = [];
            let saveNumbers = true;

            for (const betslipItem of state.betslip.items)
            {
                if (betslipItem.type !== 'lotto')
                {
                    saveNumbers = false;
                    break;
                }
                savedNumbers.push(betslipItem.meta.selectedBall);
            }

            if (saveNumbers)
            {
                if (savedNumbers.length > 1)
                {
                    savedNumbers.sort((a, b) => a - b);
                }

                window.localStorage.setItem(
                    'lottoNumbers',
                    JSON.stringify(savedNumbers),
                );

                state.savedLottoNumbers = savedNumbers;
            }
        }
    },
    setBetslipItemCallback(state)
    {
        if (state.betslip
        && this.state.offer.offerHandling.initialized)
        {
            const me = this;
            state.betslip.setItemUpdateCallback({
                callback(param)
                {
                    if (param.item && param.item.type === 'sport')
                    {
                        if (param.action === 'subscribe')
                        {
                            me.state.offer.offerHandling.subscribeTicket(
                                `${me.state.globals.globals.langCode}_match${param.item.eventId}`,
                                (match) =>
                                {
                                    param.callback({
                                        ...match,
                                        type: 'sport',
                                    });
                                },
                            );
                        }

                        if (param.action === 'unsubscribe')
                        {
                            me.state.offer.offerHandling.unsubscribe(
                                `${me.state.globals.globals.langCode}_match${param.item.eventId}`,
                                true,
                            );
                        }
                    }
                    else if (param.item && param.item.type === 'outrights')
                    {
                        if (param.action === 'subscribe')
                        {
                            me.state.offer.offerHandling.subscribeTicket(
                                `${me.state.globals.globals.langCode}_outright${param.item.eventId}`,
                                (outright) =>
                                {
                                    param.callback({
                                        ...outright,
                                        type: 'outrights',
                                    });
                                },
                            );
                        }

                        if (param.action === 'unsubscribe')
                        {
                            me.state.offer.offerHandling.unsubscribe(
                                `${me.state.globals.globals.langCode}_outright${param.item.eventId}`,
                                true,
                            );
                        }
                    }
                },
            });
        }
    },
    setBetslipGlobalRestrictions(state, data)
    {
        if (state.betslip)
        {
            state.betslip.setGlobalRestrictions(data);
        }
    },
    changeBetslipType(state, data)
    {
        if (state.betslip)
        {
            state.betslip.changeBetslipType(data);
        }
    },
    clearSavedLottoNumbers(state)
    {
        state.savedLottoNumbers = [];
        window.localStorage.setItem(
            'lottoNumbers',
            JSON.stringify(state.savedLottoNumbers),
        );
    },
    saveItemsToStorage(state)
    {
        if (state.betslip)
        {
            let type = null;

            for (const item of state.betslip.items)
            {
                const itemType = (item.type === 'outrights') ? 'sport' : item.type;

                if (type === null)
                {
                    type = itemType;
                }
                else if (type !== itemType)
                {
                    type = 'mix';
                    break;
                }
            }

            if (type != null)
            {
                if (type !== 'lotto')
                {
                    // TODO check lotto extended
                    window.localStorage.setItem(
                        type,
                        JSON.stringify(state.betslip.items),
                    );
                }
            }
        }
    },
    clearItems(state, data)
    {
        const { betslipType, type } = data;

        if (state.betslip)
        {
            state.betslip.clearItems({
                clearOtherThanType: type || null,
            });
        }

        if (!type && betslipType)
        {
            window.localStorage.setItem(
                betslipType,
                JSON.stringify([]),
            );
        }
    },
    swapLottery(state, data)
    {
        if (state.betslip)
        {
            state.betslip.clearErrorMessages();
            state.betslip.swapLottery(
                data,
                {
                    overrideLoading: true,
                    numbers: state.savedLottoNumbers,
                },
            );
        }
    },
    toggleBetslipDef(state, data)
    {
        if (state.betslip)
        {
            state.betslip.changeBetslipDefinition(data);
        }
    },
    async loadBetslipStorageItems(state, dataIn)
    {
        if (state.betslip)
        {
            const { type, skipFetch } = dataIn;

            if (!skipFetch)
            {
                let items = window.localStorage.getItem(type);
                items = JSON.parse(items);

                if (items == null)
                {
                    items = [];
                }

                const clonedData = state.betslip.getClonedBetslipData();

                clonedData.combinations = [];
                clonedData.items = items;
                clonedData.suppressErrors = true;

                const eventsUpdatedData = [];
                if (type === 'sport')
                {
                    const sportEventIds = [];
                    const outrightsEventIds = [];

                    for (const item of items)
                    {
                        if (item.type === 'sport')
                        {
                            sportEventIds.push(item.eventId);
                        }
                        else if (item.type === 'outrights')
                        {
                            outrightsEventIds.push(item.eventId);
                        }

                        item.status = 'active';
                    }

                    if (sportEventIds.length)
                    {
                        const data = await this.state.offer.offerHandling.callOffer(
                            `/${this.state.globals.globals.langCode}/sport/getMatchesByIds`,
                            {
                                matchIds: sportEventIds.join(','),
                                requestTimeout: 30 * 1000,
                            },
                        );

                        if (data
                        && data.data
                        && data.data.length)
                        {
                            for (const event of data.data)
                            {
                                eventsUpdatedData.push({
                                    type: 'sport',
                                    ...event,
                                });
                            }
                        }
                    }

                    if (outrightsEventIds.length)
                    {
                        const data = await this.state.offer.offerHandling.callOffer(
                            `/${this.state.globals.globals.langCode}/outrights/getOutrightsOffer`,
                            {
                                id: outrightsEventIds.join(','),
                                requestTimeout: 30 * 1000,
                            },
                        );

                        if (data
                        && data.data
                        && data.data.length)
                        {
                            for (const event of data.data)
                            {
                                eventsUpdatedData.push({
                                    type: 'outrights',
                                    ...event,
                                });
                            }
                        }
                    }
                }

                await state.betslip.setClonedBetslipData(clonedData);

                if (eventsUpdatedData.length)
                {
                    await state.betslip.processItemReceivedData(
                        eventsUpdatedData,
                        {
                            useBetslipItemsFormat: false,
                            findAllItems: false,
                            suppressErrors: true,
                        },
                    );
                }
            }
        }
    },
    initBetslipData(state)
    {
        const lottoNumbers = window.localStorage.getItem(
            'lottoNumbers',
        );

        if (lottoNumbers)
        {
            state.savedLottoNumbers = JSON.parse(lottoNumbers);
        }
    },
};

export default
{
    state: stateApp,
    getters,
    actions,
    mutations,
};
